import React from 'react';

/**
 * Modern minimal Card component (Zara-inspired styling)
 * Props:
 *   title: string | ReactNode
 *   subtitle: string
 *   action: ReactNode
 *   children: ReactNode
 *   className: string
 *   headerClassName: string
 *   noPadding: boolean
 */
const Card = ({
    title,
    subtitle,
    action,
    children,
    className = '',
    headerClassName = '',
    noPadding = false,
}) => {
    return (
        <div
            className={`bg-white rounded-2xl border border-stone-200/70 shadow-xs hover:shadow-md transition-all duration-200 flex flex-col justify-between overflow-hidden min-w-0 ${className}`}
        >
            {(title || action) && (
                <div
                    className={`px-6 py-4 border-b border-stone-100 flex items-center justify-between gap-4 bg-stone-50/40 min-w-0 ${headerClassName}`}
                >
                    <div className="min-w-0">
                        {title && (
                            <h3 className="text-sm font-semibold text-stone-900 tracking-tight uppercase truncate">
                                {title}
                            </h3>
                        )}
                        {subtitle && (
                            <p className="text-xs text-stone-400 mt-0.5 font-normal truncate">
                                {subtitle}
                            </p>
                        )}
                    </div>
                    {action && <div className="flex items-center gap-2 flex-shrink-0">{action}</div>}
                </div>
            )}
            <div className={`${noPadding ? '' : 'p-6'} flex-1 min-w-0`}>{children}</div>
        </div>
    );
};

export default Card;
